import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

const STIMMEN = [
  { key: "vaterstimme",   label: "Vaterstimme",    kicker: "Die männliche Präsenz",   d: "Für Väter, Söhne und Männer, die ihren inneren Vater begegnen." },
  { key: "mutterstimme",  label: "Mutterstimme",   kicker: "Die nährende Präsenz",     d: "Für Mütter, Töchter und alle, die ihre Mutter neu betrachten." },
  { key: "elternstimme",  label: "Elternstimme",   kicker: "Verbunden führen",         d: "Für Eltern, die aus Wahrheit statt aus Angst begleiten möchten." },
  { key: "maennerstimme", label: "Männerstimme",   kicker: "Reife statt Rolle",        d: "Für Männer auf dem Weg zu Klarheit, Präsenz und Herz." },
  { key: "frauenstimme",  label: "Frauenstimme",   kicker: "Wahrheit und Weichheit",   d: "Für Frauen, die ihre Kraft aus Verbindung leben." },
  { key: "kinderstimme",  label: "Kinderstimme",   kicker: "Ungehörte Sätze",          d: "Was das Kind in uns nie sagen durfte — und heute zurückkehrt." },
];

export default function StimmenSammlung() {
  return (
    <div className="min-h-screen bg-[#081328] text-white pt-32 pb-24" data-testid="stimmen-sammlung-page">
      <SEO
        title="Die Stimmen der SAT Akademie"
        description="Sechs Stimmen. Sechs Ebenen menschlicher Erfahrung. Die Stimmen-Familie der SAT Akademie."
        path="/stimmen"
      />
      <div className="container-sat max-w-5xl">
        <div className="text-center mb-16">
          <div className="overline mb-4">Die Stimmen-Familie</div>
          <h1 className="serif text-4xl md:text-6xl font-light leading-tight">
            Sechs Stimmen.
            <span className="block italic text-[#D4AF37] mt-2">Eine Familie in dir.</span>
          </h1>
          <p className="serif italic text-white/70 text-xl mt-8 max-w-2xl mx-auto leading-relaxed">
            Vater, Mutter, Kind, Mann, Frau, Eltern — jede Stimme trägt eine eigene Wahrheit.
            Die SAT-Akademie hört ihnen zu.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {STIMMEN.map((s) => (
            <Link
              key={s.key}
              to={`/${s.key}/deck`}
              className="group rounded-3xl border border-white/10 hover:border-[#D4AF37]/50 bg-white/[0.02] hover:bg-white/[0.04] p-7 transition flex flex-col"
              data-testid={`stimme-card-${s.key}`}
            >
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]/70 mb-4">{s.kicker}</div>
              <div className="serif text-2xl font-light mb-3 group-hover:text-[#D4AF37] transition">{s.label}</div>
              <p className="text-white/60 text-[14px] leading-relaxed mb-6 flex-1">{s.d}</p>
              <span className="inline-flex items-center gap-2 text-sm text-[#D4AF37] group-hover:translate-x-1 transition">
                Öffnen <ArrowRight size={14} />
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-20 text-center max-w-2xl mx-auto">
          <p className="text-white/60 text-[15px] leading-relaxed">
            Die Stimmen-Familie ist ein Social-Impact-Bereich der SAT Akademie.
            Für Beratung, Aufnahme oder Zusammenarbeit gilt der zentrale Weg:
          </p>
          <div className="mt-8">
            <Link to="/erstgespraech" className="btn-primary" data-testid="stimmen-cta-erstgespraech">
              Kostenloses Erstgespräch <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
